<template>
  <div class="pb-14 mb-14">
    <v-btn small class="mx-4" @click="$router.back()" color="info" tile outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
    </v-btn>

    <h4 class="text-center">Promociones registradas</h4>
    <v-progress-linear v-if="loading" indeterminate />
    <div class="text-right mr-2 mb-2">
      <v-btn
        small
        class=""
        @click="openmodal()"
        color="green"
        tile
        outlined
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14">
        <v-icon left small>mdi-folder-plus</v-icon> Registrar promocion
      </v-btn>
    </div>

    <v-data-table :headers="headers" :items="promociones" :itemsPerPage="200" class="elevation-2">
      <template v-slot:[`item.estudiante`]="{ item }">
        <span>
          {{ item.estudiante.primer_apellido }} {{ item.estudiante.segundo_apellido }}
          {{ item.estudiante.nombres }}
        </span>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom v-if="item.inscritos != 0">
          <template #activator="{ on, attrs }">
            <v-icon class="orange--text mr-2" v-bind="attrs" v-on="on" @click="getviewp(item)"> mdi-eye </v-icon>
          </template>
          Visualizar datos
        </v-tooltip>
        <v-tooltip
          bottom
          v-if="
            item.inscritos != 0 && !item.aprobado_por && ($store.state.CARGO.id == 1 || $store.state.CARGO.id == 14)
          ">
          <template #activator="{ on, attrs }">
            <v-icon class="green--text mr-2" v-bind="attrs" v-on="on" @click="preAprobacion(item)">
              mdi-clipboard-check-multiple
            </v-icon>
          </template>
          Aprobar Promocion
        </v-tooltip>

        <!-- <v-tooltip bottom v-if="item.inscritos != 0">
          <template #activator="{ on, attrs }">
            <v-icon class="red--text" v-bind="attrs" v-on="on" @click="preEliminacion(item)">
              mdi-delete
            </v-icon>
          </template>
          Eliminar promocion
        </v-tooltip> -->
      </template>
    </v-data-table>

    <div>
      <Create ref="createmodal" v-on:onnew="onnew" />
    </div>
    <div>
      <Viewp ref="viewmodal" />
    </div>
  </div>
</template>

<script>
  import Create from '@/views/promociones/promo-create.vue';
  import Viewp from '@/views/promociones/promo-view.vue';
  import { getdataeliminar, getdataaprobar } from '@/views/promociones/util.js';
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      loading: false,
      promociones: [{}],
      posgrado: null,
      headers: [
        { text: 'ID', value: 'id', width: 20 },
        { text: 'Nombre promocion', value: 'nombre' },
        { text: 'Creado por', value: 'creado_por', width: 120 },
        { text: 'Aprobado por', value: 'aprobado_por', width: 120 },
        { text: 'Fecha Inicio', value: 'fecha_inicio', width: 120 },
        { text: 'Fecha final', value: 'fecha_fin', width: 120 },
        { text: 'Acciones', value: 'actions', width: 130 },
      ],
    }),

    components: { Create, Viewp },
    computed: {},
    watch: {},
    methods: {
      openmodal() {
        window.console.log(this.$refs);
        this.$refs.createmodal.openmodal();
      },
      onnew() {
        this.getpromos();
      },
      getviewp(item) {
        this.$refs.viewmodal.openmodal(item);
      },
      getpromos() {
        this.loading = true;
        let vue = this;
        this.promociones = [];
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/promociones`,
          headers: {},
        };

        xaxios.request(config)
          .then(function (response) {
            let data = response.data.data;
            window.console.log(data);
            // vue.promociones = data.reverse().slice(0, 300);
            vue.promociones = data.reverse();
            vue.loading = false;
          })
          .catch(function (error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
      preAprobacion(item) {
        let vue = this;
        let dat = getdataaprobar();
        this.$dialog
          .confirm(dat.message, dat.options)
          .then(function (dialog) {
            vue.eliminar(item, dialog);
          })
          .catch(function () {});
      },
      preEliminacion() {
        let vue = this;
        let dat = getdataeliminar();
        this.$dialog
          .confirm(dat.message, dat.options)
          .then(function (dialog) {
            vue.loadingediting = true;
            dialog.close();
          })
          .catch(function () {});
      },
      eliminar(item, dialog) {
        let vue = this;
        let us = this.$store.state.DATA_USER;
        if (!us.seg_apellido) us.seg_apellido = '';
        let usuario = `${us.nombres} ${us.pri_apellido} ${us.seg_apellido}`.trim();

        var config = {
          method: 'patch',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/promociones`,
          headers: {},
          data: {
            id: item.id,
            aprobado_por: usuario,
          },
        };

        xaxios.request(config)
          .then(function (response) {
            let data = response.data.data;
            window.console.log(data);
            vue.getpromos();
            dialog.close();
          })
          .catch(function (error) {
            window.console.log(error);
            dialog.close();
          });
      },
    },
    mounted() {
      this.getpromos();
    },
  };
</script>
